// extracted by mini-css-extract-plugin
export default {"subtitle":"styles_subtitle__WfmTo"};